var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "term-of-service-modal",
        title: _vm.$t("message.privacyPolicyAndTerms"),
        okText: _vm.$t("message.termsModalOkReadAgree"),
        cancelText: _vm.$t("message.cancel"),
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: function ($event) {
          return _vm.$emit("agree")
        },
      },
    },
    [
      _c(
        "a-tabs",
        { attrs: { "default-active-key": _vm.type } },
        [
          _c(
            "a-tab-pane",
            { key: "pp", attrs: { tab: _vm.$t("message.privacyPolicyTab") } },
            [
              _c("div", { staticClass: "term-of-service-modal-content" }, [
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.privacyPolicyTitle"))),
                  ]),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyDescription"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.informationWeCollect"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("message.weCollectFollowingInformation"))
                  ),
                ]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.customerAccountInformation"))),
                ]),
                _vm._v(": " + _vm._s(_vm.$t("message.customerAccountData"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.userInformation")))]),
                _vm._v(
                  ": " + _vm._s(_vm.$t("message.userProvidedInformation"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.dataDeletionProcess"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.dataDeletionProcedures"))),
                ]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.automaticDeletion")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.automaticDeletionInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.directRequest")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.directRequestInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.websiteVisitorDataDeletion"))),
                ]),
                _vm._v(
                  ": " +
                    _vm._s(_vm.$t("message.websiteVisitorDataDeletionInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [_vm._v(_vm._s(_vm.$t("message.howToContactUs")))]),
                ]),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.contactChannels")))]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyContactChannelsLine"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.dataProcessingAndSharing"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.handleCustomerData")))]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.noThirdPartySharing"))),
                ]),
                _vm._v(
                  ": " + _vm._s(_vm.$t("message.noThirdPartySharingInfo"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.promotionalEmails")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.promotionalEmailsInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.visitorAndConversationData"))),
                ]),
                _vm._v(": " + _vm._s(_vm.$t("message.noSharingVisitorData"))),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.thirdPartyServices"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("h5", [
                  _c("b", [_vm._v(_vm._s(_vm.$t("message.googleOAuth")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.googleCalendar")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.googleCalendarInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.googleAccountPublicProfile"))),
                ]),
                _vm._v(
                  ": " +
                    _vm._s(_vm.$t("message.googleAccountPublicProfileInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.termsYoutubeApiHeading"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.termsYoutubeApiAcknowledgeBeforeLink")
                    ) +
                    "\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.google.com/policies/privacy",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("message.googlePrivacyPolicyLinkText"))
                    ),
                  ]
                ),
                _vm._v(".\n                "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.termsYoutubeDataAccessTitle"))),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsYoutubeDataAccessBody"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.termsYoutubeCookiesTitle"))),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsYoutubeCookiesBody"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.termsYoutubeRetentionTitle"))),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsYoutubeRetentionBody"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.termsYoutubeDeletionTitle"))),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsYoutubeDeletionBody"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.termsYoutubeRevokingTitle"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsYoutubeRevokePartBeforeLink")) +
                    "\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://myaccount.google.com/connections",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("message.googleAccountConnectionsPageUrl"))
                    ),
                  ]
                ),
                _vm._v(
                  _vm._s(_vm.$t("message.termsYoutubeRevokePartAfterLink")) +
                    "\n                "
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.changesToPrivacyPolicy"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyUpdateInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyContactInfo")) +
                    "\n            "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "tac",
              attrs: {
                tab: _vm.$t("message.termsAndConditionsTab"),
                "force-render": "",
              },
            },
            [
              _c("div", { staticClass: "term-of-service-modal-content" }, [
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.termsOfServiceTitle"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsTcLeadLine")) +
                    " " +
                    _vm._s(_vm.$t("message.importantTerms"))
                ),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsDescription"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("1 " + _vm._s(_vm.$t("message.applicationOfTerms"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsApplyToAllUsers")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsUpdateNotice")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsDisagreementNotice")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.consumerRightsNotice")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("2 " + _vm._s(_vm.$t("message.theService")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceGrant")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAccess")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAgentAppointment")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.additionalAccountsAppointment")
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.accountControl")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAffiliation")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceLinks")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentMonitoring")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceControl")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "3 " + _vm._s(_vm.$t("message.yourRightsAndObligations"))
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentAdditionRestriction")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.restrictionsOnServiceUse")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("4 " + _vm._s(_vm.$t("message.payments")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.paymentAcknowledgment"))),
                ]),
                _vm._v(":\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.paymentMethodDebit")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.cancellationPolicy")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("5 " + _vm._s(_vm.$t("message.intellectualProperty"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentDefinition")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.intellectualPropertyRightsTransfer")
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.userContentRights")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.grantLicense")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.subLicense")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.moralRights")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.licenseSurvival")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.rightsRepresentation")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("6 " + _vm._s(_vm.$t("message.warranties")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.warrantiesAcknowledgment"))),
                ]),
                _vm._v(":\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.accountOwnership"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.serviceUsageAgreement"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.legalCapacity")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("7 " + _vm._s(_vm.$t("message.liability")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.liabilityForLoss"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.indemnification")))]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.exclusionOfLiability"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.totalLiabilityLimit"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.exclusionOfTerms"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.statutoryObligations"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.statuteProhibition"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("8 " + _vm._s(_vm.$t("message.termination"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationAutomatic"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationNotice"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.cancelService")))]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationRights"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("9 " + _vm._s(_vm.$t("message.general")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.assignmentRestriction"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.invalidProvision"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.expenseResponsibility"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.governingLaw")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.termsSection10Heading"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("message.termsYoutubeApiServicesBold"))
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.termsSection10YoutubeAgreeBeforeLink")
                        ) +
                        "\n                        "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/t/terms",
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.youtubeTermsOfServiceLinkText")
                          )
                        ),
                      ]
                    ),
                    _vm._v(".\n                    "),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }